<template>
	<!-- 统计 -->
	<div class="statistics">
		<div class="top">
			<div class="item">
				<div class="title">
					<div class="name">
						<div class="padding"></div>
						应急保电订单统计
					</div>
					<div class="filter">
<!--						<el-select v-model="value1" placeholder="请选择" size="mini" @change="chang1">-->
<!--							<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">-->
<!--							</el-option>-->
<!--						</el-select>-->
						<el-date-picker
								v-model="time1"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="-"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								@input="chang1"
								:clearable="false"
								:picker-options="pickerOptions">
						</el-date-picker>
					</div>
				</div>
				<div class="area">
					<div class="left">
						<div class="value">{{ eme.a1 }}</div>
						<div class="key">应急保电订单</div>
					</div>
					<div class="right">
						<div class="tab">
							待确认：
							<span>{{ eme.a2 }}</span>
						</div>
						<div class="tab">
							待收款并发货：
							<span>{{ eme.a3 }}</span>
						</div>
<!--						<div class="tab">-->
<!--							待发货：-->
<!--							<span>{{ eme.a4 }}</span>-->
<!--						</div>-->
						<div class="tab">
							待续费：
							<span>{{ eme.a5 }}</span>
						</div>
						<div class="tab">
							待结算：
							<span>{{ eme.a6 }}</span>
						</div>
						<div class="tab">
							已完成：
							<span>{{ eme.a7 }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="item">
				<div class="title">
					<div class="name">
						<div class="padding"></div>
						成套设备租赁订单统计
					</div>
					<div class="filter">
<!--						<el-select v-model="value2" placeholder="请选择" size="mini" @change="chang2">-->
<!--							<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">-->
<!--							</el-option>-->
<!--						</el-select>-->
						<el-date-picker
								v-model="time2"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="-"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								@input="chang2"
								:clearable="false"
								:picker-options="pickerOptions">
						</el-date-picker>
					</div>
				</div>
				<div class="area">
					<div class="left">
						<div class="value">{{ equ.b1 }}</div>
						<div class="key">成套设备订单</div>
					</div>
					<div class="right">
						<div class="tab">
							待确认：
							<span>{{ equ.b2 }}</span>
						</div>
						<div class="tab">
							待收款：
							<span>{{ equ.b3 }}</span>
						</div>
						<div class="tab">
							待安装验收：
							<span>{{ equ.b4 }}</span>
						</div>
						<div class="tab">
							已完成：
							<span>{{ equ.b5 }}</span>
						</div>
<!--						<div class="tab">-->
<!--							已完成：-->
<!--							<span>{{ equ.ywc }}</span>-->
<!--						</div>-->
					</div>
				</div>
			</div>
		</div>
		<div class="bottom">
			<div class="item">
				<div class="title">
					<div class="name">
						<div class="padding"></div>
						应急保电订单收入统计
					</div>
					<span>提示：总额中包含平台扣除的收入。</span>
					<div class="filter">
<!--						<el-select v-model="value3" placeholder="请选择" size="mini" @change="chang3">-->
<!--							<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">-->
<!--							</el-option>-->
<!--						</el-select>-->
						<el-date-picker
								v-model="time3"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="-"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								@input="chang3"
								:clearable="false"
								:picker-options="pickerOptions">
						</el-date-picker>
					</div>
				</div>
				<div class="table">
					<div class="middle">
						<div class="left">
							<div class="value">¥{{ emeOrder.c1 }}</div>
							<div class="key">应急保电收入总额</div>
						</div>
						<div class="right">
							<div class="tab">
								订单金额：
								<span>{{ emeOrder.c2 }}</span>
							</div>
							<!-- <div class="tab">
								退款金额：
								<span>{{ emeOrder.refund }}</span>
							</div> -->
							<div class="tab">
								平台服务费：
								<span>{{ emeOrder.c3 }}</span>
							</div>
							<div class="tab">
								实际收入：
								<span>{{ emeOrder.c4 }}</span>
							</div>
							<div class="tab">
								退款租金油费：
								<span>{{ emeOrder.c5 }}</span>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="item">
				<div class="title">
					<div class="name">
						<div class="padding"></div>
						成套设备租赁订单收入统计
					</div>
					<span>提示：总额中包含平台扣除的收入。</span>
					<div class="filter">
<!--						<el-select v-model="value4" placeholder="请选择" size="mini" @change="chang4">-->
<!--							<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id">-->
<!--							</el-option>-->
<!--						</el-select>-->
						<el-date-picker
								v-model="time4"
								type="daterange"
								align="right"
								unlink-panels
								range-separator="-"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								@input="chang4"
								:clearable="false"
								:picker-options="pickerOptions">
						</el-date-picker>
					</div>
				</div>
				<div class="table">
					<div class="middle">
						<div class="left">
							<div class="value">¥{{ equOrder.d1 }}</div>
							<div class="key">成套设备收入总额</div>
						</div>
						<div class="right">
							<div class="tab">
								订单金额：
								<span>{{ equOrder.d2 }}</span>
							</div>
							<div class="tab">
								平台服务费：
								<span>{{ equOrder.d3 }}</span>
							</div>
							<div class="tab">
								实际收入：
								<span>{{ equOrder.d4 }}</span>
							</div>
						</div>
					</div>

				</div>


			</div>


		</div>
		<div class="bottom">

			<div class="item100">

				<el-table :data="tableData">
					<el-table-column prop="orderNo" label="订单号"></el-table-column>
					<el-table-column label="工程名称" align="center" prop="projectname" />
					<el-table-column label="客户信息" align="center" prop="masterName" />
					<el-table-column label="订单类型" align="center" prop="orderType">
						<template slot-scope="scope">
							<span v-if="scope.row.orderType == 0">成套设备租赁</span>
							<span v-else>应急保电</span>
						</template>
					</el-table-column>
					<el-table-column
							label="开始时间"
							align="center"
							prop="startTime"
							width="180"
					>
						<template slot-scope="scope">
							<span>{{ scope.row.startTime|formatDate}}</span>
						</template>
					</el-table-column>
					<el-table-column
							label="实际收入"
							align="center"
							prop="sjsr"
					></el-table-column>
					<el-table-column label="状态" align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.orderType == 0">
								<div>
									{{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'
										: scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 24 ? '待厂商支付服务费'
												: scope.row.orderSatus == 34 ? '待平台确认服务费': scope.row.orderSatus == 5 ? '待厂商安装验收'
														: scope.row.orderSatus == 6 ? '待客户用电完成' : scope.row.orderSatus == 7 ? '已完成'
																: scope.row.orderSatus == 8 ? '已完成(已评价)' : scope.row.orderSatus == 70 ? '中止订单' : '其他'}}
								</div>
							</div>
							<div v-else>
               <span>
            {{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'
									 : scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 4 ? '待厂商确认收款并发货'
											 : scope.row.orderSatus == 6 ? '待客户收货'
													 : scope.row.orderSatus == 7 ? '待厂商确认用电完成' : scope.row.orderSatus == 11 ? '待客户确认用电完成'
															 : scope.row.orderSatus == 18 ? '待平台出具结算单' : scope.row.orderSatus == 28 ? '待厂商结算'
																	 : scope.row.orderSatus == 29 ? '待客户收款': scope.row.orderSatus == 8 ? '已完成'
																			 : scope.row.orderSatus == 9 ? '已评价': scope.row.orderSatus == 60 ? '待厂商确认续费'
																					 : scope.row.orderSatus == 70 ? '中止订单':'其他'
								 }}
          </span>
								<span v-if="(scope.row.orderSatus==8||scope.row.orderSatus==29||scope.row.orderSatus==9)&&scope.row.serviceFeeStatus==1">(待收取服务费)</span>
								{{scope.row.orderSatus==7&&scope.row.status!=60?"(可续费)":''}}
							</div>
						</template>
					</el-table-column>
<!--					<el-table-column-->
<!--							label="操作"-->
<!--							align="center"-->
<!--							class-name="small-padding fixed-width"-->
<!--					>-->
<!--&lt;!&ndash;						<template slot-scope="scope">&ndash;&gt;-->
<!--&lt;!&ndash;							<el-button size="mini" type="text" @click="handleSee(scope.row)"&ndash;&gt;-->
<!--&lt;!&ndash;							>查看</el-button&ndash;&gt;-->
<!--&lt;!&ndash;							>&ndash;&gt;-->
<!--&lt;!&ndash;						</template>&ndash;&gt;-->
<!--					</el-table-column>-->
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button
									size="mini"
									type="text"
									icon="el-icon-edit"
									@click="handleSee(scope.row)"
							>查看</el-button
							>
						</template>
					</el-table-column>
				</el-table>

				<div
						style="
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        padding-bottom: 20px;
      "
						v-if="total1 > queryParams.pageSize"
				>
				<el-pagination background layout="prev, pager, next,total" :total="total1" :page-size="queryParams.pageSize"
											 @current-change="handleCurrentChange">
				</el-pagination>
				</div>
<!--				<pagination-->
<!--						v-show="total1 > 0"-->
<!--						:total="total1"-->
<!--						:page.sync="queryParams.pageNum"-->
<!--						:limit.sync="queryParams.pageSize"-->
<!--						@pagination="getOrderList"-->
<!--				/>-->
			</div>


		</div>

	</div>
</template>

<script>
import {
	equOrderListS, equOrderListS070,
	sta1Api,
	sta2Api,
	sta3Api,
	sta4Api, staApiAll
} from '../../http/factory/add-eme.js'
	export default {
		name: 'statistics',
		data() {
			return {
				time1:[
					new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
					'-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
							'0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
							(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
					"-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
					new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
				],
				time2:[
					new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
					'-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
							'0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
							(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
					"-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
					new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
				],
				time3:[
					new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
					'-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
							'0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
							(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
					"-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
					new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
				],
				time4:[
					new Date(new Date().setMonth(new Date().getMonth()-3)).getFullYear() +
					'-' +(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1<10?
							'0'+(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1):
							(new Date(new Date().setMonth(new Date().getMonth()-3)).getMonth()+1))+
					"-" + new Date(new Date().setMonth(new Date().getMonth()-3)).getDate(),
					new Date().getFullYear() + '-' +(new Date().getMonth()+1<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1))+ "-" + new Date().getDate()
				],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 1);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 3);
							picker.$emit('pick', [start, end]);
						}}
						, {
							text: '最近一年',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setFullYear(start.getFullYear() - 1);
								picker.$emit('pick', [start, end]);
							}
						}]
				},
				tableData:[],
				total1:0,
				queryParams:{
					pageNum: 1,
					pageSize: 10,
					is_firm: 1,
					superType: 2,
				},
				options: [{
						label: '7天',
						id: 7
					},
					{
						label: '15天',
						id: 15
					},
					{
						label: '30天',
						id: 30
					},
					{
						label: '90天',
						id: 90
					}
				],
				value1: 7,
				value2: 7,
				value3: 7,
				value4: 7,
				eme: {},
				equ: {},
				emeOrder: {
					total: 0,
					money: 0,
					refund: 0,
					deduct: 0,
					real: 0,
					list: []
				},
				equOrder: {
					total: 0,
					money: 0,
					deduct: 0,
					real: 0,
					list: []
				}
			};
		},
		created() {
			this.getSta1()
			this.getSta2()
			this.getSta3()
			this.getSta4()
			this.getOrderList()
		},
		filters: {
			formatDate(date1) {
				let date = new Date(date1)
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hour = String(date.getHours()).padStart(2, '0');
				const minute = String(date.getMinutes()).padStart(2, '0');

				// 格式化为 'YYYY-MM-DD HH:mm' 的形式
				return `${year}-${month}-${day}`;
			}
		},
		methods: {
			handleSee(row) {
				this.$router.push({
					path: row.orderType == 1 ? "/factoryUser/factoryDetailEme" : "/factoryUser/factoryDetailEqu",
					query: {
						id: row.id,
					},
				});
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val;
				this.getOrderList();
			},
			getOrderList() {
					equOrderListS070(
						this.queryParams
					).then((res) => {
						this.tableData = res.rows;
						this.total1=res.total
					});
				// },
			},
			chang1(val) {
				this.value1 = val
				this.getSta1()
			},
			getSta1() {
				staApiAll({
					type:"pctongji",
					startTime:this.time1[0],
					endTime:this.time1[1]
				}).then(res => {
					console.log(res)
					this.eme = res
				})
			},
			getSta2() {
				staApiAll({
					type:"pctongji",
					startTime:this.time2[0],
					endTime:this.time2[1]
				}).then(res => {
					this.equ = res
				})
			},
			getSta3() {
				staApiAll({
					type:"pctongji",
					startTime:this.time3[0],
					endTime:this.time3[1]
				}).then(res => {
					this.emeOrder = res
				})
			},
			getSta4() {
				staApiAll({
					type:"pctongji",
					startTime:this.time4[0],
					endTime:this.time4[1]
				}).then(res => {
					this.equOrder = res
				})
			},

			chang2(val) {
				this.value2 = val
				this.getSta2()
			},
			chang3(val) {
				this.value3 = val
				this.getSta3()
			},
			chang4(val) {
				this.value4 = val
				this.getSta4()
			}
		}
	};
</script>

<style lang="less" scoped="scoped">
	.statistics {
		width: 100%;
	}

	.top {
		width: 100%;
		height: 200px;
		display: flex;
		justify-content: space-between;

		.item {
			width: 49%;
			height: 100%;
			background: @vue-bg-color;
			padding: 0px @vue-spacing-row-base;
			box-sizing: border-box;
		}

		.area {
			width: 100%;
			height: 150px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left {
				width: 180px;
				border-right: 1px dashed @vue-border-color;
				box-sizing: border-box;

				.value {
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: @vue-font-size-base;
					font-weight: bold;
				}

				.key {
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
					color: @vue-text-color-grey;
				}
			}

			.right {
				width: calc(100% - 180px);
				height: 100%;
				display: flex;
				flex-wrap: wrap;
				align-content: center;

				.tab {
					width: 33.3%;
					height: 40px;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
					color: @vue-text-color-grey;

					span {
						color: @vue-text-color;
					}
				}
			}
		}
	}

	.bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-top: @vue-spacing-col-lg;

		.item100 {
			width: 100%;
			background: @vue-bg-color;
			padding: 0px @vue-spacing-row-base;
			box-sizing: border-box;
		}
		.item {
			width: 49%;
			background: @vue-bg-color;
			padding: 0px @vue-spacing-row-base;
			box-sizing: border-box;
		}

		.middle {
			width: 100%;
			height: 150px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.left {
				width: 180px;
				border-right: 1px dashed @vue-border-color;
				box-sizing: border-box;

				.value {
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: @vue-font-size-base;
					font-weight: bold;
				}

				.key {
					width: 100%;
					height: 40px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
					color: @vue-text-color-grey;
				}
			}

			.right {
				width: calc(100% - 180px);
				height: 100%;
				display: flex;
				flex-wrap: wrap;
				align-content: center;

				.tab {
					width: 50%;
					height: 40px;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm - 2;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
					color: @vue-text-color-grey;

					span {
						color: @vue-text-color;
					}
				}
			}
		}

		ul {
			width: 100%;
			border-top: 1px solid @vue-border-color;

			li {
				width: 100%;
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid @vue-border-color;

				.list-line-tab {
					width: 30%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.list-line-tab:last-child {
					width: 40%;
				}
			}

			.list-head {
				height: 50px;

				.list-line-tab {
					font-size: @vue-font-size-sm - 2;
					color: @vue-text-color-grey;
				}
			}

			.list-line {
				height: 80px;

				.list-line-tab {
					font-size: @vue-font-size-sm - 2;
				}

				.list-line-money {
					width: 40%;
					padding: 10px 0px;
					box-sizing: border-box;

					.list-line-get,
					.list-line-pay {
						width: 100%;
						height: 30px;
						line-height: 30px;
						display: flex;
						justify-content: flex-end;
						align-items: center;
						font-size: @vue-font-size-sm - 2;
					}

					.list-line-pay {
						color: @vue-text-color-grey;

						span {
							color: @vue-text-color-red;
							margin-left: @vue-spacing-row-sm;
						}
					}
				}
			}
		}
	}

	.title {
		width: 100%;
		height: 50px;
		border-bottom: 1px solid @vue-border-color;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;

		.name {
			height: 100%;
			display: flex;
			align-items: center;
		}

		.padding {
			width: 4px;
			height: 14px;
			background: #ff5252;
			margin-right: @vue-spacing-row-sm;
		}

		span {
			font-size: @vue-font-size-min;
			color: @vue-text-color-grey;
		}
	}
</style>
